// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GXQPVYNEYG4hNHamZsW6 {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.sMqV3vet3781wO7fleK7 {
  --hc-color-neutral-900: white;
}
`, "",{"version":3,"sources":["webpack://./src/lib/components/genericErrorBoundary/errorBoundary.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".box {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.dark {\n  --hc-color-neutral-900: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `GXQPVYNEYG4hNHamZsW6`,
	"dark": `sMqV3vet3781wO7fleK7`
};
export default ___CSS_LOADER_EXPORT___;
